/**
 * @title Page requiring access
 * @description Pages that require personal access
 */
import * as React from "react";
import {FC} from "react";
import {Route, Routes} from "react-router-dom";
import {ReturnsPage} from "./returns/ReturnsPage";
import {LoginProvider} from "./LoginProvider";
import {ProfilePage} from "./profile/ProfilePage";
import {GlobalLayout, StyledDiv} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {DeliveryPage} from "./delivery/DeliveryPage";
import {TradeInRouter} from "./tradein/TradeInRouter";
import {PayoutPage} from "./payout/PayoutPage";
import {useRecoilValue} from "recoil";
import {LoginContext} from "../LoginContext";
import {HistoryPage} from "./history/HistoryPage";
import {GlobalStyles} from "@mui/material";
import clsx from "clsx";
import {CommentsPage} from "./comments/CommentsPage";

export const PrivatePage: FC<any> = () => {
   const {accessToken, preview} = useRecoilValue(LoginContext);
   const classes = useStyles();
   const layout = useRecoilValue(GlobalLayout);

   return <LoginProvider accessToken={accessToken!} preview={preview || false}>
      <GlobalStyles styles={{
         "#tradeinroot *": {
            fontSize: layout.text?.fontSize
         },
         "#tradeinroot svg": {
            fontSize: "1.5rem !important"
         }
      }}/>
      <StyledDiv type={"main"} className={classes.page}>
         <div className={clsx(classes.container, 'c2s-private-router')}>
            <Routes>
               <Route path={"/"} element={<ReturnsPage/>}/>
               <Route path={"comments"} element={<CommentsPage/>}/>
               <Route path={"profile"} element={<ProfilePage/>}/>
               <Route path={"delivery"} element={<DeliveryPage/>}/>
               <Route path={"payout"} element={<PayoutPage/>}/>
               <Route path={"history"} element={<HistoryPage/>}/>
               <Route path={"tradein/:tradeInId/*"} element={<TradeInRouter/>}/>
            </Routes>
         </div>
      </StyledDiv>
   </LoginProvider>
}


const useStyles = makeStyles({
   page: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'start',
   },
   container: {
      width: '1000px',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column'
   },
   '@media only screen and (max-width: 1000px)': {
      container: {
         width: '100%'
      } as any,
   },
});